module.exports = __webpack_public_path__ + "static/media/Sy.b7d2ee61.PNG";